import { render } from '@/render';
import { Page404 } from './404';

render(<Page404 />);
